import makeStyles from '@material-ui/core/styles/makeStyles';
import { PURE_GRAY } from '../../../utils/colors/colors.contants';

export default makeStyles({
  divider: {
    backgroundColor: PURE_GRAY,
  },
});
